import {
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import {Language} from '../../common/enums/language.enum';
import {AppTranslateService} from '../../services/infrastructure/page/i18n/translate/app-translate/app-translate.service';
import {IQuestionCategoryItem} from '../../models/insurer-interview.model';

@Pipe({
  name: 'nameQuestionCategory',
  pure: false,
})
export class NameQuestionCategoryPipe implements PipeTransform {

  private appTranslateService = inject(AppTranslateService);

  transform(value: IQuestionCategoryItem): string {
    const currentLang = this.appTranslateService.getCurrentAppLanguage();
    if (currentLang === Language.en) {
      return value?.englishName || '';
    }
    if (currentLang === Language.de) {
      return value?.germanName || '';
    }
    if (currentLang === Language.fr) {
      return value?.frenchName || '';
    }
    if (currentLang === Language.it) {
      return value?.italianName || '';
    }
    return '';
  }

}
